import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ADPResourceService } from 'digital-core';
import { MatSidenav } from '@angular/material/sidenav';
import { Subject, Subscription, combineLatest, concatMap, filter, tap } from 'rxjs';
import { NextStepsInfoDeviceTemplate } from 'src/app/modules/device-diagnostics/components/next-steps/next-steps.component';
import { ImeiInfoDeviceType } from 'src/app/modules/device-diagnostics/components/imei-info/imei-info.component';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { AccountService } from 'src/app/core/services/account.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { ImeiLookupDeviceTemplate, ImeiResult } from '../components/imei-lookup/imei-lookup.component';
import { DeviceInfoFormResult } from '../components/cellular-device-info-form/cellular-device-info-form.component';
import { ContractDeviceInventories } from 'src/app/core/services/contract-device-inventories';
import { SerialLookupDeviceTemplate, SerialResult } from '../components/serial-lookup/serial-lookup.component';
import { EssItemGroup } from 'src/app/shared/equipment-search/ess-item-group';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog-data';
import { MatDialog } from '@angular/material/dialog';
import { dashboardRouteWithSlash } from 'src/app/route-constants';
import { UserInfoReportingService } from 'src/app/core/services/user-info-refporting.service';
import { UpdateUserInfoDevicesCountDto } from 'src/app/model/account/update-user-info-devices-count.dto';
import { UserClaims } from '@okta/okta-auth-js';
import { StorageService } from 'src/app/core/services/storage.service';
@Component({
  selector: 'pgh-smartwatch-registration',
  templateUrl: './smartwatch-registration.component.html',
  styleUrls: ['./smartwatch-registration.component.scss']
})
export class SmartwatchRegistrationComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<void>();

  public EssItemGroupEnum = EssItemGroup;

  states = {
    RegisterSmartwatchDamageQuestionnaire: 1,
    RegisterSmartwatchNextSteps: 2,
    RegisterImeiQuestionnaire: 3,
    RegisterSmartwatchIMEIInfo: 4,
    SerialInfo: 5,
    ProvideAdditionalInfo: 6,
    GenerateQRCode: 7
  }
  @ViewChild('imeisidenav') sidenav: MatSidenav;
  events: string[] = [];
  opened: boolean;

  state = this.states.RegisterSmartwatchDamageQuestionnaire;
  private registerDeviceInProgress = false;
  invitationCode:string;
  invitationId:string;
  inventoryId:number;
  hasImei: boolean;
  imeiStepResult: ImeiResult;
  serialStepResult: SerialResult;
  backLabel: string;

  device: PghUserDeviceBase;
  public preSelectedDevice?: PghUserDeviceBase;
  public devicesFromAllInventories?: DeviceDto[];
  private subscriptions: Subscription[] = [];

  public isOnboardingFlow:boolean = false;
  public isAdditionalDeviceFlow:boolean =  false;
  public additionalDeviceTypeCode:string='SMAR';

  private deviceInventories?: ContractDeviceInventories;

  private isDamaged:boolean = true;

  public imeiInfoDeviceType:ImeiInfoDeviceType=ImeiInfoDeviceType.Smartwatch;
  public nextStepsInfoDeviceTypeTemplate:NextStepsInfoDeviceTemplate=NextStepsInfoDeviceTemplate.Smartwatch;
  public imeiLookupDeviceTypeTemplate:ImeiLookupDeviceTemplate=ImeiLookupDeviceTemplate.Smartwatch;

  public serialLookupDeviceTemplate = SerialLookupDeviceTemplate;
  public userEmail:string;

  constructor(
    public resourceService: ADPResourceService,
    private router: Router,
    public route: ActivatedRoute,
    private location: Location,
    private deviceInventoryService: DeviceInventoryService,
    private selectedDeviceService: SelectedDeviceService,
    private accountService: AccountService,
    private loggedInUserSettingsService: LoggedInUserSettings,
    private dialog: MatDialog,
    private userInfoReportingService: UserInfoReportingService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");

    this.route.queryParams.subscribe(params => {
      this.isOnboardingFlow = (params.isOnboardingFlow && params.isOnboardingFlow.toLowerCase().trim() === 'true');
    });

    this.route.queryParams.subscribe(params => {
      this.isAdditionalDeviceFlow = (params.isAdditionalDeviceFlow && params.isAdditionalDeviceFlow.toLowerCase().trim() === 'true');
    });

    if(!this.isAdditionalDeviceFlow){
      this.preSelectedDevice = this.selectedDeviceService.getSelectedDevice();
    }

    this.accountService.getAllInventoriesWithDevicesForSelectedContract(this.onDestroy$).subscribe({
      next: (inventories) => {
        this.deviceInventories = inventories;

        this.devicesFromAllInventories = [
          ...(inventories?.cellularEnabledPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetPolicyInventory?.devices ?? []),
          ...(inventories?.gadgetClientSoldPolicyInventory?.devices ?? []),
          ...(this.deviceInventoryService?.getEprismDevices()),
        ];
      },
      error: (error) => {
        throw error;
      }
    });
    this.loggedInUserSettingsService.$userClaims.subscribe({
      next: (user)=>{
        this.userEmail = user.email;
      }
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  changeState(state: any): void {
    this.state = state;
    if (this.state == this.states.RegisterSmartwatchIMEIInfo || this.state == this.states.RegisterSmartwatchNextSteps || this.state == this.states.ProvideAdditionalInfo) {
      this.backLabel = this.resourceService.getPortaLabelValue("Global_Button_Back");
    } else {
      this.backLabel = this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices"); // This is for the QR Code screen
    }
    this.gotoTop();
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  public handleImeiLookupCompleted(result: ImeiResult) {
    this.imeiStepResult = result;
    this.changeState(this.states.ProvideAdditionalInfo);
  }

  handleSerialLookupCompleted(result: SerialResult) {
    this.serialStepResult = result;
    this.changeState(this.states.ProvideAdditionalInfo);
  }

  handleImeiQuestionnaireCompleted(deviceHasImei: boolean){
    if (deviceHasImei) {
      this.changeState(this.states.RegisterSmartwatchIMEIInfo);
      this.hasImei = true;
    } else {
      this.changeState(this.states.SerialInfo);
      this.hasImei = false;
    }
  }

  public handleDeviceInfoFormSubmitted(deviceFormResult: DeviceInfoFormResult) {
    const isEprism = this.storageService.getLocal<string>(`IsEprismOnly`);
    if (this.registerDeviceInProgress || isEprism == 'true') {
      return;
    }
    this.registerDeviceInProgress = true;

    if (this.hasImei) {
      this.inventoryId = this.deviceInventories?.cellularEnabledPolicyInventory ? this.deviceInventories?.cellularEnabledPolicyInventory?.info?.id : this.deviceInventories?.gadgetPolicyInventory?.info?.id;
    } else if(!this.hasImei){
      this.inventoryId = this.deviceInventories?.gadgetPolicyInventory?.info?.id;
      // Reset imei value to null to guarantee it does not have a value if serial number chosen after imei input in same flow
      this.imeiStepResult = null;
    }

    const createDeviceDto = this.deviceInventoryService.buildCreateDeviceBodyDtoFromSerialSearchEquipmentInfo(
      this.inventoryId, deviceFormResult, this.imeiStepResult?.imei, this.serialStepResult?.serial, 'SMAR');

    this.deviceInventoryService.createDevice(createDeviceDto).pipe(
      tap(device => this.selectedDeviceService.updateAllDevices(this.deviceInventoryService.buildPghUserDeviceBaseFromDeviceDto(device))),
      tap(() => this.deviceInventoryService.clearCache()),
      concatMap(device => this.accountService.registerInvitationToDevice(device.id, device.inventoryId, false)),
    ).subscribe({
      next: (res) => {
        this.invitationCode = res.invitationCode;
        this.invitationId = res.id;
        this.changeState(this.states.GenerateQRCode);
        this.registerDeviceInProgress = false;

         //update the user's inventory device count in the UserInfo db
        const updateUserInfoDevicesCountDto : UpdateUserInfoDevicesCountDto = {
          EmailAddress: this.userEmail,
          DeviceCount: this.selectedDeviceService.getAllDevices().length
        }
        this.userInfoReportingService.updateUserInfoDevicesCount(updateUserInfoDevicesCountDto).subscribe({error: (err) => { throw err;}});
      },
      error: (error) => {
        this.registerDeviceInProgress = false;
        throw error;
      },
    });
  }

  handleRegisterQuestionnaire(e:any) {
    this.isDamaged = e.data[0].isDamaged;
    if (!this.isDamaged) {
      this.changeState(e.state);
    } else if(!this.isAdditionalDeviceFlow){
      this.backLabel = this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices");
    }
  }

  handleBack() {
    if (this.state == this.states.RegisterSmartwatchNextSteps) {
      this.changeState(this.states.RegisterSmartwatchDamageQuestionnaire);
    } else if (this.state == this.states.RegisterSmartwatchDamageQuestionnaire) {
      if (this.backLabel != this.resourceService.getPortaLabelValue("RegisterNumber_Back_To_My_Devices") && window.history.length > 1) {
        this.location.back();
      } else {
        this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
      }
    } else if (this.state == this.states.RegisterImeiQuestionnaire) {
      this.changeState(this.states.RegisterSmartwatchNextSteps);
    } else if(this.state == this.states.RegisterSmartwatchIMEIInfo) {
      this.changeState(this.states.RegisterImeiQuestionnaire);
    } else if (this.state == this.states.SerialInfo) {
      this.changeState(this.states.RegisterImeiQuestionnaire);
    } else if (this.state == this.states.ProvideAdditionalInfo) {
      if(this.hasImei){
        this.changeState(this.states.RegisterSmartwatchIMEIInfo);
      }else{this.changeState(this.states.SerialInfo);}
    } else {
      this.router.navigate([this.resourceService.getPortalSetting("URL_MyDevices").Value]);
    }
  }

  closeSideNav() {
    this.sidenav.close();
  }

  public handleExitToDashboard(){

    let dialogData: ConfirmationDialogData;

    dialogData = {
        title: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Title",
        message: "RegisterCellularDevice_AdditionalDevice_Questionnaire_Modal_Message",
        cancelButtonText: "Global_Button_SkipForNow",
        confirmButtonText: "Global_Button_ContinueTest",
        contextData: { titleLeftAligned: false }
      };

    const confirmationDialog = this.dialog.open<ConfirmationDialogComponent, ConfirmationDialogData, boolean>(ConfirmationDialogComponent, {
      data: dialogData
    });
    this.subscriptions.push(confirmationDialog.afterClosed().subscribe({
      next: (result) => {
        if (result.toString() === 'false') {
          this.router.navigate([dashboardRouteWithSlash]);
        }
      }
    }));
  }
}
